export const nlGraphicDesign = {
  title: "Professionele Grafische Ontwerpdiensten",
  description: "Creatieve visuele oplossingen die de boodschap van uw merk communiceren en uw publiek boeien op alle media.",
  subtitle: "Oplossingen voor Grafisch Ontwerp",

  servicesTitle: "Onze Ontwerp Expertise",
  servicesSubtitle: "Uitgebreide visuele ontwerpdiensten voor al uw behoeften",
  services: {
    branding: {
      title: "Merkidentiteit",
      description: "Complete brandingpakketten inclusief logo's, kleurpaletten en visuele stijlgidsen.",
      technologies: ["Logo Ontwerp", "Typografie", "Kleurenleer", "Merkrichtlijnen", "Visuele Identiteit"]
    },
    print: {
      title: "Printontwerp",
      description: "Indrukwekkende ontwerpen voor visitekaartjes, brochures, posters en ander drukwerk.",
      technologies: ["Visitekaartjes", "Brochures", "Flyers", "Briefpapier", "Printlay-out"]
    },
    digital: {
      title: "Digitale Grafische Vormgeving",
      description: "Social media assets, web graphics en digitale advertenties die opvallen.",
      technologies: ["Social Media Graphics", "Banners", "Web Assets", "E-mail Templates", "Digitale Advertenties"]
    },
    illustration: {
      title: "Aangepaste Illustratie",
      description: "Originele kunstwerken en illustraties afgestemd op de persoonlijkheid van uw merk.",
      technologies: ["Vector Art", "Karakterontwerp", "Iconensets", "Digitale Schilderkunst", "Handgetekende Stijlen"]
    },
    packaging: {
      title: "Verpakkingsontwerp",
      description: "Aantrekkelijke productverpakkingen die uw product verkopen voordat het geopend is.",
      technologies: ["Labelontwerp", "Doosontwerp", "Productverpakking", "3D Mockups", "Structureel Ontwerp"]
    },
    motion: {
      title: "Motion Graphics",
      description: "Geanimeerde ontwerpen en visuele effecten die uw merk tot leven brengen.",
      technologies: ["Geanimeerde Logo's", "Uitlegvideo's", "UI Animaties", "Titel Sequenties", "Motion Design"]
    }
  },

  processTitle: "Ons Ontwerpproces",
  processSteps: [
    {
      title: "Ontdekking & Onderzoek",
      description: "We leren uw merk, doelgroep en ontwerpvereisten kennen."
    },
    {
      title: "Conceptontwikkeling",
      description: "Het creëren van eerste ontwerpconcepten en visuele richtingen."
    },
    {
      title: "Ontwerpverfijning",
      description: "Itereren op geselecteerde concepten om de visuele uitvoering te perfectioneren."
    },
    {
      title: "Klantfeedback",
      description: "Samenwerken met u om de ontwerpen te verfijnen en aan te passen."
    },
    {
      title: "Finalisatie",
      description: "Het voorbereiden van definitieve bestanden in alle vereiste formaten en specificaties."
    },
    {
      title: "Levering & Ondersteuning",
      description: "Het leveren van alle assets en voortdurende ontwerp ondersteuning indien nodig."
    }
  ]
};

export const deGraphicDesign = {
  title: "Professionelle Grafikdesign-Dienstleistungen",
  description: "Kreative visuelle Lösungen, die die Botschaft Ihrer Marke vermitteln und Ihr Publikum auf allen Medien begeistern.",
  subtitle: "Grafikdesign-Lösungen",

  servicesTitle: "Unsere Design-Expertise",
  servicesSubtitle: "Umfassende visuelle Design-Dienstleistungen für alle Ihre Anforderungen",
  services: {
    branding: {
      title: "Markenidentität",
      description: "Komplette Branding-Pakete einschließlich Logos, Farbpaletten und visuellen Styleguides.",
      technologies: ["Logo-Design", "Typografie", "Farbtheorie", "Markenrichtlinien", "Visuelle Identität"]
    },
    print: {
      title: "Printdesign",
      description: "Beeindruckende Designs für Visitenkarten, Broschüren, Poster und andere Druckerzeugnisse.",
      technologies: ["Visitenkarten", "Broschüren", "Flyer", "Briefpapier", "Printlayout"]
    },
    digital: {
      title: "Digitale Grafiken",
      description: "Social Media Assets, Webgrafiken und digitale Anzeigen, die herausstechen.",
      technologies: ["Social Media Grafiken", "Banner", "Web-Assets", "E-Mail-Vorlagen", "Digitale Anzeigen"]
    },
    illustration: {
      title: "Individuelle Illustration",
      description: "Originalkunstwerke und Illustrationen, die auf die Persönlichkeit Ihrer Marke zugeschnitten sind.",
      technologies: ["Vektorgrafik", "Charakterdesign", "Icon-Sets", "Digitale Malerei", "Handgezeichnete Stile"]
    },
    packaging: {
      title: "Verpackungsdesign",
      description: "Auffällige Produktverpackungen, die Ihr Produkt verkaufen, bevor es überhaupt geöffnet wird.",
      technologies: ["Etikettendesign", "Boxdesign", "Produktverpackung", "3D Mockups", "Strukturelles Design"]
    },
    motion: {
      title: "Motion Graphics",
      description: "Animierte Designs und visuelle Effekte, die Ihre Marke zum Leben erwecken.",
      technologies: ["Animierte Logos", "Erklärvideos", "UI-Animationen", "Titelsequenzen", "Motion Design"]
    }
  },

  processTitle: "Unser Designprozess",
  processSteps: [
    {
      title: "Entdeckung & Recherche",
      description: "Wir lernen Ihre Marke, Ihr Publikum und Ihre Designanforderungen kennen."
    },
    {
      title: "Konzeptentwicklung",
      description: "Erstellung erster Designkonzepte und visueller Richtungen."
    },
    {
      title: "Designverfeinerung",
      description: "Iterieren an ausgewählten Konzepten, um die visuelle Umsetzung zu perfektionieren."
    },
    {
      title: "Kundenfeedback",
      description: "Zusammenarbeit mit Ihnen, um die Designs zu verfeinern und anzupassen."
    },
    {
      title: "Finalisierung",
      description: "Vorbereitung der finalen Dateien in allen erforderlichen Formaten und Spezifikationen."
    },
    {
      title: "Lieferung & Support",
      description: "Bereitstellung aller Assets und fortlaufende Designunterstützung nach Bedarf."
    }
  ]
};
export const enGraphicDesign = {
  // Hero Section
  title: "Professional Graphic Design Services",
  description: "Creative visual solutions that communicate your brand's message and captivate your audience across all mediums.",
  subtitle: "Graphic Design Solutions",

  // Services Section
  servicesTitle: "Our Design Expertise",
  servicesSubtitle: "Comprehensive visual design services for all your needs",
  services: {
    branding: {
      title: "Brand Identity",
      description: "Complete branding packages including logos, color palettes, and visual style guides.",
      technologies: ["Logo Design", "Typography", "Color Theory", "Brand Guidelines", "Visual Identity"]
    },
    print: {
      title: "Print Design",
      description: "Stunning designs for business cards, brochures, posters, and other printed materials.",
      technologies: ["Business Cards", "Brochures", "Flyers", "Stationery", "Print Layout"]
    },
    digital: {
      title: "Digital Graphics",
      description: "Social media assets, web graphics, and digital advertisements that stand out.",
      technologies: ["Social Media Graphics", "Banners", "Web Assets", "Email Templates", "Digital Ads"]
    },
    illustration: {
      title: "Custom Illustration",
      description: "Original artwork and illustrations tailored to your brand's personality.",
      technologies: ["Vector Art", "Character Design", "Icon Sets", "Digital Painting", "Hand-drawn Styles"]
    },
    packaging: {
      title: "Packaging Design",
      description: "Eye-catching product packaging that sells your product before it's even opened.",
      technologies: ["Label Design", "Box Design", "Product Packaging", "3D Mockups", "Structural Design"]
    },
    motion: {
      title: "Motion Graphics",
      description: "Animated designs and visual effects that bring your brand to life.",
      technologies: ["Animated Logos", "Explainer Videos", "UI Animations", "Title Sequences", "Motion Design"]
    }
  },

  // Process Section
  processTitle: "Our Design Process",
  processSteps: [
    {
      title: "Discovery & Research",
      description: "We learn about your brand, audience, and design requirements."
    },
    {
      title: "Concept Development",
      description: "Creating initial design concepts and visual directions."
    },
    {
      title: "Design Refinement",
      description: "Iterating on selected concepts to perfect the visual execution."
    },
    {
      title: "Client Feedback",
      description: "Collaborating with you to refine and adjust the designs."
    },
    {
      title: "Finalization",
      description: "Preparing final files in all required formats and specifications."
    },
    {
      title: "Delivery & Support",
      description: "Providing all assets and ongoing design support as needed."
    }
  ]
};


export const frGraphicDesign = {
  title: "Services Professionnels de Design Graphique",
  description: "Solutions visuelles créatives qui communiquent le message de votre marque et captivent votre audience sur tous les supports.",
  subtitle: "Solutions de Design Graphique",

  servicesTitle: "Notre Expertise en Design",
  servicesSubtitle: "Services de design visuel complets pour tous vos besoins",
  services: {
    branding: {
      title: "Identité de Marque",
      description: "Packages de branding complets incluant logos, palettes de couleurs et guides de style visuel.",
      technologies: ["Design de Logo", "Typographie", "Théorie des Couleurs", "Directives de Marque", "Identité Visuelle"]
    },
    print: {
      title: "Design Imprimé",
      description: "Designs époustouflants pour cartes de visite, brochures, affiches et autres supports imprimés.",
      technologies: ["Cartes de Visite", "Brochures", "Flyers", "Papeterie", "Mise en Page Imprimée"]
    },
    digital: {
      title: "Graphiques Numériques",
      description: "Actifs pour les réseaux sociaux, graphiques web et publicités numériques qui se démarquent.",
      technologies: ["Graphiques pour les Réseaux Sociaux", "Bannières", "Actifs Web", "Modèles d'Email", "Publicités Numériques"]
    },
    illustration: {
      title: "Illustration Personnalisée",
      description: "Œuvres d'art et illustrations originales adaptées à la personnalité de votre marque.",
      technologies: ["Art Vectoriel", "Design de Personnages", "Ensembles d'Icônes", "Peinture Numérique", "Styles Dessinés à la Main"]
    },
    packaging: {
      title: "Design d'Emballage",
      description: "Emballages de produits accrocheurs qui vendent votre produit avant même qu'il ne soit ouvert.",
      technologies: ["Design d'Étiquettes", "Design de Boîtes", "Emballage de Produits", "Maquettes 3D", "Design Structurel"]
    },
    motion: {
      title: "Graphiques Animés",
      description: "Designs animés et effets visuels qui donnent vie à votre marque.",
      technologies: ["Logos Animés", "Vidéos Explicatives", "Animations UI", "Séquences de Titres", "Design de Mouvement"]
    }
  },

  processTitle: "Notre Processus de Design",
  processSteps: [
    {
      title: "Découverte & Recherche",
      description: "Nous apprenons à connaître votre marque, votre audience et vos exigences en matière de design."
    },
    {
      title: "Développement de Concepts",
      description: "Création de concepts de design initiaux et de directions visuelles."
    },
    {
      title: "Affinement du Design",
      description: "Itération sur les concepts sélectionnés pour perfectionner l'exécution visuelle."
    },
    {
      title: "Retour Client",
      description: "Collaboration avec vous pour affiner et ajuster les designs."
    },
    {
      title: "Finalisation",
      description: "Préparation des fichiers finaux dans tous les formats et spécifications requis."
    },
    {
      title: "Livraison & Support",
      description: "Fourniture de tous les actifs et support de design continu selon les besoins."
    }
  ]
};